import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Fade, useMediaQuery } from '@material-ui/core';

// UTILITY
import { analyticsHoverOnApp } from '@/utility/analytics';

// HOC
import Measure from '@/hoc/Measure';

// HELP
import AppCardWithContent from './help/AppCardWithContent';
import AppCard from './help/AppCard';

// STYLES
import { TooltipPopperComponent } from './styles';

const AppCardWithTooltip = ({
  data,
  className,
  onUpdateStatus,
  onRemoveStatus,
  location,
  tooltip,
  tooltipProps,
  swimlaneAnalytics,
  hideControls,
  linkProps,
  btnProps,
  type,
}) => {
  const matchesUpSm = useMediaQuery(({ breakpoints }) => breakpoints.up('sm'));
  const hasSwimlaneAnalytics = !!Object.keys(swimlaneAnalytics).length;
  let LinkProps = { ...linkProps };

  if (hasSwimlaneAnalytics) {
    LinkProps = {
      ...LinkProps,
      analyticsType: 'app-card',
      analyticsProps: {
        ...swimlaneAnalytics,
        app_name: data.name,
        app_id: data.id,
      },
    };
  }

  const hasTooltip = matchesUpSm && tooltip;

  const card = (
    <AppCard
      data={data}
      className={className}
      location={location}
      LinkProps={LinkProps}
      hideControls={hideControls}
      btnProps={btnProps}
      type={type}
    />
  );

  if (!hasTooltip) {
    return card;
  }

  const onEntered = () => {
    const properties = {
      ...swimlaneAnalytics,
      app_name: data.name,
      app_id: data.id,
    };

    analyticsHoverOnApp(properties);
  };

  return (
    <Measure>
      {([ref, { width, height }]) => {
        return (
          <Tooltip
            PopperComponent={TooltipPopperComponent}
            TransitionComponent={Fade}
            PopperProps={{
              $cardWidth: width,
              $cardHeight: height,
            }}
            placement="right-start"
            arrow={false}
            interactive
            enterDelay={100}
            enterNextDelay={200}
            title={
              <AppCardWithContent
                data={data}
                className={className}
                onUpdateStatus={onUpdateStatus}
                onRemoveStatus={onRemoveStatus}
                location={location}
                LinkProps={LinkProps}
                hideControls={hideControls}
              />
            }
            TransitionProps={{ onEntered }}
            {...tooltipProps}
          >
            <div ref={ref}>{card}</div>
          </Tooltip>
        );
      }}
    </Measure>
  );
};

AppCardWithTooltip.defaultProps = {
  className: '',
  onUpdateStatus: () => {},
  onRemoveStatus: () => {},
  location: '',
  tooltip: true,
  tooltipProps: {},
  swimlaneAnalytics: {},
  hideControls: false,
  linkProps: {},
  btnProps: {},
  type: 'default',
};

AppCardWithTooltip.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string,
  onUpdateStatus: PropTypes.func,
  onRemoveStatus: PropTypes.func,
  location: PropTypes.string,
  tooltip: PropTypes.bool,
  tooltipProps: PropTypes.object,
  swimlaneAnalytics: PropTypes.object,
  hideControls: PropTypes.bool,
  linkProps: PropTypes.object,
  btnProps: PropTypes.object,
  type: PropTypes.oneOf(['default', 'promotions']),
};

export default React.memo(AppCardWithTooltip);
